import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { SessionService } from '../auth/session.service';
import { Permission } from '../models/user.model';

/**
 * Route needs the permission, or any one of a list (none: every signed-in user). Signed-out users pass here:
 * `authGuard` on the shell then sends them to sign-in with this page as the return URL (not to "No access",
 * which they would land on after signing in).
 * Usage: `{ path: 'orders', canMatch: [permissionGuard('orders.view')], loadChildren: ... }`
 */
export function permissionGuard(permission?: Permission | readonly Permission[]): CanMatchFn {
  return () => {
    const session = inject(SessionService);
    if (!session.isAuthenticated() || !permission) return true;
    return session.hasPermission(permission) ? true : inject(Router).createUrlTree(['/forbidden']);
  };
}
